import styled, {css} from 'styled-components';
import {media, primaryColor, primaryForeground, primaryHover} from '../utils/variables';
import {Layout} from './layout';

export const profileAvatarVisual = css`
  background: ${primaryColor};
  border-radius: 50%;
  color: ${primaryForeground};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  line-height: 1;
`;

export const profileAvatarSize = css`
  height: 40px;
  width: 40px;

  ${media.mobile} {
    height: 30px;
    width: 30px;
    font-size: 12px;
  }

  ${media.tablet} {
    height: 30px;
    width: 30px;
    font-size: 15px;
  }
`;

export const ProfileAvatar = styled.div`
  ${profileAvatarVisual}
  ${profileAvatarSize}
`;

export const ProfileIcon = styled(Layout)`
  ${profileAvatarVisual}
  ${profileAvatarSize}
  cursor: pointer;
  border: none;
  padding: 0;
  font-family: inherit;
  font-size: inherit;
  user-select: none;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    background: ${primaryHover};
    box-shadow: 0 2px 8px rgba(43, 127, 255, 0.3);
  }

  &:focus-visible {
    outline: 2px solid ${primaryColor};
    outline-offset: 2px;
  }
`;
